import api from "../services/api";

import { eStatus, IUsuario, Roles } from "../interfaces";

interface IUsuarioLoginModel {
    login: string;
    senha: string;
}

interface IUsuarioPutModel {
    id: string;
    nome: string;
    login: string;
    senha: string;
    novaSenha: string;
    confirmacao: string;
    userLevel: Roles;
    status: eStatus;
    trocaSenha: boolean;
}

interface IUsuarioPutModelReset {
    id: string;
}

interface IUsuarioResponse {
    usuario: IUsuario;
    message: string;
}

interface IAuthResponse {
    token: string;
}

class UsuarioRepository {

    public GetById = async (id: string): Promise<IUsuario> => {
        const response = await api.get<IUsuario>(`usuario/${id}`);

        return response.data;
    }

    public LogIn = async ({ login, senha }: IUsuarioLoginModel): Promise<IAuthResponse> => {
        const response = await api.post<IAuthResponse>("/auth", { login, senha, });
        return response.data;
    }

    public Update = async ({ id, nome, login, senha, novaSenha, confirmacao, userLevel, status, trocaSenha }: IUsuarioPutModel) => {
        const response = await api.put<IUsuarioResponse>(`usuario/${id}`, {
            nome,
            login,
            senha,
            novaSenha,
            confirmacao,
            userLevel,
            status,
            trocaSenha
        });
        return response.data;
    }
    public Reset = async ({ id }: IUsuarioPutModelReset) => {
        const response = await api.put<IUsuarioResponse>(`usuario/${id}/reset`);

        return response.data;
    }
}

const usuarioRepository = new UsuarioRepository();
export default usuarioRepository;
